import { render, staticRenderFns } from "./IconCameraToggle.vue?vue&type=template&id=4959d7da&scoped=true"
import script from "./IconCameraToggle.vue?vue&type=script&lang=js"
export * from "./IconCameraToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959d7da",
  null
  
)

export default component.exports